import Endpoints from "../../utils/Endpoints";
import { axiosConfig } from "../../utils/Utils";
import axios from "axios";
import { useAppContext } from "../../context/AuthContext";

interface AuthorControllerType {
  axiosGetSearchAuthorList: any;
  axiosGetShortAuthorList: any;
}

export function AuthorController(): AuthorControllerType {
  const { authData } = useAppContext();

  const axiosGetSearchAuthorList = (data: any) => {
    return axios.get(`${Endpoints.ARTICLE}/author/find`, axiosConfig(authData!.token, data));
  };

  const axiosGetShortAuthorList = (data: any) => {
    return axios.get(`${Endpoints.ARTICLE}/author/short-list`, axiosConfig(authData!.token, data));
  };

  return { axiosGetSearchAuthorList, axiosGetShortAuthorList };
}

export type { AuthorControllerType };
